import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const CircleArrowIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["system.red.900"],
  ...props
}) => {
  return (
    <Svg
      width={width}
      height={height}
      {...props}
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMin meet"
    >
      <Path
        d="M9.84087 13.1075C9.67587 12.9425 9.59727 12.7361 9.60507 12.4883C9.61227 12.2411 9.69837 12.035 9.86337 11.87C10.0284 11.705 10.2384 11.6225 10.4934 11.6225C10.7484 11.6225 10.9584 11.705 11.1234 11.87L11.9334 12.68L11.9334 9.7775C11.9334 9.5225 12.0198 9.3125 12.1926 9.1475C12.3648 8.9825 12.5784 8.9 12.8334 8.9C13.0884 8.9 13.3023 8.9861 13.4751 9.1583C13.6473 9.3311 13.7334 9.545 13.7334 9.8L13.7334 12.68L14.5659 11.8475C14.7309 11.6825 14.9373 11.6036 15.1851 11.6108C15.4323 11.6186 15.6384 11.705 15.8034 11.87C15.9684 12.035 16.0509 12.245 16.0509 12.5C16.0509 12.755 15.9684 12.965 15.8034 13.13L13.4634 15.47C13.2834 15.65 13.0734 15.74 12.8334 15.74C12.5934 15.74 12.3834 15.65 12.2034 15.47L9.84087 13.1075ZM3.83337 12.5C3.83337 13.745 4.06977 14.915 4.54257 16.01C5.01477 17.105 5.65587 18.0575 6.46587 18.8675C7.27587 19.6775 8.22837 20.3186 9.32337 20.7908C10.4184 21.2636 11.5884 21.5 12.8334 21.5C14.0784 21.5 15.2484 21.2636 16.3434 20.7908C17.4384 20.3186 18.3909 19.6775 19.2009 18.8675C20.0109 18.0575 20.6523 17.105 21.1251 16.01C21.5973 14.915 21.8334 13.745 21.8334 12.5C21.8334 11.255 21.5973 10.085 21.1251 8.99C20.6523 7.895 20.0109 6.9425 19.2009 6.1325C18.3909 5.3225 17.4384 4.6814 16.3434 4.2092C15.2484 3.7364 14.0784 3.5 12.8334 3.5C11.5884 3.5 10.4184 3.7364 9.32337 4.2092C8.22837 4.6814 7.27587 5.3225 6.46587 6.1325C5.65587 6.9425 5.01477 7.895 4.54257 8.99C4.06977 10.085 3.83337 11.255 3.83337 12.5ZM5.63338 12.5C5.63338 10.505 6.33447 8.8061 7.73667 7.4033C9.13947 6.0011 10.8384 5.3 12.8334 5.3C14.8284 5.3 16.5273 6.0011 17.9301 7.4033C19.3323 8.8061 20.0334 10.505 20.0334 12.5C20.0334 14.495 19.3323 16.1936 17.9301 17.5958C16.5273 18.9986 14.8284 19.7 12.8334 19.7C10.8384 19.7 9.13947 18.9986 7.73667 17.5958C6.33447 16.1936 5.63338 14.495 5.63338 12.5Z"
        fill={color}
      />
    </Svg>
  );
};

export default CircleArrowIcon;
